module.exports = {"370403001":"临城街道","370403002":"兴仁街道","370403003":"兴城街道","370403004":"张范街道","370403101":"沙沟镇","370403102":"周营镇","370403103":"邹坞镇","370403104":"陶庄镇","370403106":"常庄镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370403.json
// module id = 1279
// module chunks = 0